<div class="stadion-info">
  <div class="row">
    <div class="col-md-12 stadion" *ngIf="stadion; else noStadium">
      <div class="seperator-headline">
        <div class="seperator-headline__line"></div>
        <h5 *ngIf="stadion.name">{{ stadion.name }}</h5>
      </div>
      <div class="iframe-wrapper card-shadow">
        <div class="adress-wrapper">
          <span>Adresse: </span> {{ stadion.address }}
        </div>
        <div id="google-map"></div>
      </div>
    </div>
    <ng-template #noStadium>
      <div class="col-md-12 stadion">
        <div class="seperator-headline">
          <div class="seperator-headline__line"></div>
          <h5 >Stadion</h5>
        </div>
        <div class="iframe-wrapper card-shadow">
          Für dieses Team wurde noch kein Stadion eingetragen.
        </div>
      </div>
    </ng-template>
  </div>
</div>
